import { memo } from 'react'

import { Illustrations } from 'atoms'
import Layouts from 'organisms/web/Layouts'

import { ResponsivePageNotFoundScreenComponent } from './PageNotFoundScreen.types'

const PageNotFoundScreenDesktop: ResponsivePageNotFoundScreenComponent = memo(({ goToStart }) => (
  <Layouts.Error
    title="Página não encontrada"
    description="Não achamos a página que você procura. Sugerimos que você volte à página inicial enquanto corrigimos o problema."
    handleActionButton={goToStart}
    nameActionButton="Ir para o início">
    <Illustrations.PageNotFound width={500} height={500} />
  </Layouts.Error>
))

export default PageNotFoundScreenDesktop
